// extracted by mini-css-extract-plugin
export default {"Form":"Form_Form__dxr-m","buttonArea":"Form_buttonArea__rQXy9"};